import { allFirewallQueryAtom, type FirewallWithType } from "@/modules/network/firewall/firewallApi.ts";
import {
    allAssignedLbAndIpsQueryAtom,
    type IpAddressWithPrice,
    type LoadBalancerWithPrice,
} from "@/modules/network/ipAddress/joinAssignedQuery.ts";
import type * as vpcOps from "@/modules/network/vpc/vpcApi.ts";
import { allVpcsQueryAtom } from "@/modules/network/vpc/vpcApi.ts";
import { mergeQueries, type QMergedResult } from "@/utils/query/mergeQueries.ts";
import { useAtomValue } from "jotai/react";
import { atom } from "jotai/vanilla";

export type NetworkListItem = LoadBalancerWithPrice | IpAddressWithPrice | vpcOps.VpcWithType | FirewallWithType;
export type NetworkListData = NetworkListItem[];

export type NetworkListQResult = QMergedResult<NetworkListData>;

export const networkListQueryAtom = atom((get): NetworkListQResult => {
    const vpcs = get(allVpcsQueryAtom);
    const ips = get(allAssignedLbAndIpsQueryAtom);
    const firewalls = get(allFirewallQueryAtom);
    return mergeQueries({ vpcs, ips, firewalls }, (maps) => maps.flatMap((m) => [...m.values()]));
});

export function useNetworkListQuery() {
    return useAtomValue(networkListQueryAtom);
}
